import { render, staticRenderFns } from "./VehicleMakeListEdit.vue?vue&type=template&id=068e15c0&"
import script from "./VehicleMakeListEdit.vue?vue&type=script&lang=js&"
export * from "./VehicleMakeListEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports